import { get, post } from "@insite/client-framework/Services/ApiService";

export const getSecondarySalesPersonAPI = async (id: string) => {
    const response = await get<any>(`/api/v2/SecondarySalesPerson/GetByCustomer/${id}`);
    return response;
};

export const secondarySalesPersonAssignAPI = async (parameter: any) => {
    const response = await post<any>("/api/v2/SecondarySalesPerson/Assign", parameter);
    return response;
};

